/**
 * Tip - an explanation behind a small "?" beside a row's label (DEC-318, operator 2026-10-26: "any inspector
 * paragraph, sentence should be hidden behind a mouse over ? icon"). Hover shows it with a mouse; a tap shows it on the
 * iPad, which has no hover; one is open at a time and a tap anywhere else closes it. Copied from
 * `public/button-look-study.html` rev 12.
 *
 * Only for EXPLANATIONS. A warning or a live status ("No scene chosen - this button does nothing yet") stays on view:
 * it says what is happening now, and hiding it would hide a fault.
 */

import { createSignal, onCleanup, onMount } from 'solid-js';

const [openTip, setOpenTip] = createSignal<symbol | null>(null);
let listeners = 0;
const closeOnOutside = (e: PointerEvent) => {
  if (!(e.target as Element | null)?.closest?.('.ip-tip')) setOpenTip(null);
};

export function Tip(props: { text: string }) {
  const id = Symbol('tip');
  onMount(() => { if (listeners++ === 0) document.addEventListener('pointerdown', closeOnOutside, true); });
  onCleanup(() => {
    if (openTip() === id) setOpenTip(null);
    if (--listeners === 0) document.removeEventListener('pointerdown', closeOnOutside, true);
  });
  return (
    <button
      type="button"
      class="ip-tip"
      data-tip={props.text}
      aria-label={props.text}
      aria-expanded={openTip() === id}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpenTip(openTip() === id ? null : id); }}
    >
      ?
    </button>
  );
}

/** A label with its ? and nothing else, for an explanation that belongs to a group of rows rather than one. */
export function TipRow(props: { label: string; text: string }) {
  return (
    <div class="inspector-pills inspector-tip-row">
      <span class="inspector-pills-label">{props.label}<Tip text={props.text} /></span>
    </div>
  );
}
